import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { ref, reactive } from 'vue';
import { validatePassword, jsMd5 } from '@/utils/index';
import { ElMessage, ElMessageBox } from 'element-plus';
import CommonForm from '@/components/CommonForm.vue';
import { post } from '@/api/srm/common/common';
import { Base64 } from 'js-base64';
const serviceID = 'ZFSRM_BC_LOGIN_SRV';
const eneitySet = 'change_passwordSet';
export default /*#__PURE__*/_defineComponent({
  __name: 'changePass',
  setup(__props, {
    expose: __expose
  }) {
    const innerIsShow = ref(false);
    const formRef = ref();
    const loading = ref(false);
    const formObj = reactive({
      schema: {
        properties: {
          Password: {
            type: 'string',
            title: '密码'
          },
          ConfirmPassword: {
            type: 'string',
            title: '确认密码'
          }
        }
      },
      formSchema: ['Password', 'ConfirmPassword'],
      formUiSchema: {
        Password: {
          span: 22,
          slot: true
        },
        ConfirmPassword: {
          span: 22,
          slot: true
        }
      },
      formData: {},
      itemInfoRules: {
        Password: [{
          required: true,
          validator: validatePassword,
          trigger: 'blur'
        }],
        ConfirmPassword: [{
          required: true,
          validator: validateConfirmPasword,
          trigger: 'blur'
        }]
      }
    });
    // 密码校验
    function validateConfirmPasword(rule, value) {
      const val = rule.cellValue || value || '';
      if (val === '') {
        return Promise.reject(new Error('请再次输入密码'));
      }
      if (val !== formObj.formData.Password) {
        return Promise.reject(new Error('两次输入密码不一致!'));
      }
      return Promise.resolve();
    }
    async function validateform() {
      const formValidate = await formRef.value.validateForm();
      return formValidate;
    }
    function open() {
      innerIsShow.value = true;
    }
    function handleClosed() {
      innerIsShow.value = false;
      formRef.value.resetFields();
    }
    async function handleConfirm() {
      const valid = await validateform();
      if (!valid) {
        return ElMessage.error('请检查输入项');
      }
      ElMessageBox.confirm('您是否确认修改密码?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        confirmChangePass();
      });
    }
    async function confirmChangePass() {
      loading.value = true;
      const bname = localStorage.getItem('CsUsername');
      const mdBname = jsMd5(bname);
      const b6Pass = Base64.encode(mdBname + formObj.formData.Password);
      const data = {
        Bname: bname,
        Password: b6Pass,
        MsgSet: [{}]
      };
      const res = await post(serviceID, eneitySet, data).catch(e => {
        console.log(e);
        loading.value = false;
      });
      loading.value = false;
      if (res === undefined) {
        return ElMessage.error('密码修改失败');
      } else {
        const mesType = res.d.MsgSet.results[0].Type;
        const mes = res.d.MsgSet.results[0].MessageText;
        if (mesType === 'S') {
          handleClosed();
          return ElMessage.success(mes);
        } else {
          return ElMessage.error(mes);
        }
      }
    }
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        title: "修改密码",
        modelValue: innerIsShow.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => innerIsShow.value = $event),
        width: "35%",
        modal: true,
        "close-on-click-modal": false,
        onClosed: handleClosed
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: handleClosed,
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleConfirm,
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode("保 存")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(CommonForm, {
          ref_key: "formRef",
          ref: formRef,
          schema: formObj.schema,
          formSchema: formObj.formSchema,
          "form-ui-schema": formObj.formUiSchema,
          formData: formObj.formData,
          "label-mode": _ctx.labelMode,
          loading: loading.value,
          labelWidth: 120,
          rules: formObj.itemInfoRules
        }, {
          Password: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formObj.formData.Password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formObj.formData.Password = $event),
            type: "password",
            "show-password": "true",
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          ConfirmPassword: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formObj.formData.ConfirmPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formObj.formData.ConfirmPassword = $event),
            type: "password",
            "show-password": "true",
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["schema", "formSchema", "form-ui-schema", "formData", "label-mode", "loading", "rules"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});